export default API => ({
  myOrderList () {
    return API({ url: '/order/v1/open/order/myOrderList'})
  }, 
  myOrderList2 (params) {
    return API({ 
      url: '/order/v1/open/order/myOrderListWithPage',
      method: 'GET',
      params
    })
  }, 
  changeTaskApply({ params, data }) {
      return API({ url: '/market/v1/customer/save', method:'post', params, data });
  },
})
